export default __webpack_public_path__ + "static/media/audio.bf2dfe12.svg";